var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA1LogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 494,
    viewBox: "0 0 482 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.626 150.198C335.626 150.198 370.685 138.702 398.867 111.109L398.93 134.096C383.759 146.783 363.418 153.554 363.418 153.554L335.626 150.198Z",
    fill: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.777 0L464.715 14.2774C467.158 101.437 466.988 189.166 464.147 276.326C464.147 275.7 464.147 275.074 464.147 274.448L464.033 315.411L481.931 303.122V17.7478L464.777 0Z",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.777 14.1663L464.777 0L408.923 8.07877C403.98 22.814 397.332 55.186 335.626 86.4201V150.198C335.626 150.198 370.684 138.705 398.866 111.112V310.35L464.038 315.414L464.152 274.451C461.709 187.86 461.936 100.7 464.777 14.1663Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.777 14.1587C467.277 101.375 467.05 189.161 464.152 276.321C461.652 189.104 461.879 101.318 464.777 14.1587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.086 464.643L283.927 387.383L255.167 388.671L273.813 453.265L306.086 464.643Z",
    fill: "#820000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.994 315.698L209.437 216.136L225.119 164.477L268.188 315.698H236.994Z",
    fill: "#820000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.188 71.9694L177.845 54.8446L151.481 130.853C120.401 226.604 87.5589 322.639 53.3535 417.707C115.912 398.875 157.447 360.131 189.266 315.698H179.266L225.119 164.477L239.665 215.567C269.04 134.324 268.188 71.9694 268.188 71.9125V71.9694Z",
    fill: "#FF3F36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.609 72.1969L268.188 71.9694C268.188 71.9694 269.041 134.264 239.666 215.564L268.188 315.698H189.266C157.447 360.131 115.912 398.875 53.3535 417.707C44.1487 443.195 34.9439 468.683 25.5687 494L134.151 482.622L159.663 392.958L283.927 387.383L306.087 464.643L383.816 456.166L269.609 72.1969Z",
    fill: "#EB140A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.146 122.676C153.578 124.496 152.953 126.26 152.384 128.08L177.838 54.8617L139.032 74.8288L-0.00549316 472.794L25.5707 494.005C65.7421 369.808 108.861 245.109 154.089 122.676H154.146Z",
    fill: "#B80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.151 122.661C113.98 246.858 70.7972 371.567 25.5688 494C65.7402 369.803 108.923 245.094 154.151 122.661V122.661Z",
    fill: "#FDC9C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 482,
    height: 494,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1LogoDark);
export default __webpack_public_path__ + "static/media/a1_logo_dark.43a7c3b088e426284760fcca42a13a91.svg";
export { ForwardRef as ReactComponent };